import Vue from 'vue'
import Moment from 'moment'

Vue.filter('computeAge', function (birthdate) {
  return ~~((Date.now() - new Date(birthdate)) / (31557600000));
});